/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

/**
 * An org-scoped time window, optionally narrowed to one project
 */
export type TelemetryWindowPayload = {
  /**
   * Start time in ISO 8601 format
   */
  from: Date;
  /**
   * Optional project to scope to; defaults to every project in the organization.
   */
  projectId?: string | undefined;
  /**
   * End time in ISO 8601 format
   */
  to: Date;
};

/** @internal */
export type TelemetryWindowPayload$Outbound = {
  from: string;
  project_id?: string | undefined;
  to: string;
};

/** @internal */
export const TelemetryWindowPayload$outboundSchema: z.ZodMiniType<
  TelemetryWindowPayload$Outbound,
  TelemetryWindowPayload
> = z.pipe(
  z.object({
    from: z.pipe(z.date(), z.transform(v => v.toISOString())),
    projectId: z.optional(z.string()),
    to: z.pipe(z.date(), z.transform(v => v.toISOString())),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectId: "project_id",
    });
  }),
);

export function telemetryWindowPayloadToJSON(
  telemetryWindowPayload: TelemetryWindowPayload,
): string {
  return JSON.stringify(
    TelemetryWindowPayload$outboundSchema.parse(telemetryWindowPayload),
  );
}
